import { render } from "./BackPosLeftbar.vue?vue&type=template&id=6f90f1c4&scoped=true"
import script from "./BackPosLeftbar.vue?vue&type=script&lang=js"
export * from "./BackPosLeftbar.vue?vue&type=script&lang=js"

import "./BackPosLeftbar.vue?vue&type=style&index=0&id=6f90f1c4&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f90f1c4"]])

export default __exports__